import React, { useState, useEffect } from "react";
import { Col, Row, Table, Badge } from "react-bootstrap";
import Spinner from "react-bootstrap/Spinner";
import PrescriptionService from "services/prescription.service";
import AuthService from "services/auth.service";
import moment from "moment";

import ReadyIcon from "assets/icons/erx-ready-icon.svg";
import PrepareIcon from "assets/icons/erx-prepare-icon.svg";
import PaymentIcon from "assets/icons/erx-delivery-payment-icon.svg";
import ProcessingIcon from "assets/icons/erx-delivery-processing-icon.svg";
import DeliveringIcon from "assets/icons/erx-delivering-icon.svg";
import DeliveredIcon from "assets/icons/erx-delivered.svg";
import DeliveryFailedIcon from "assets/icons/erx-delivery-failed-icon.svg";
import DeliveryExpiredIcon from "assets/icons/erx-delivery-expired-icon.svg";
import DeliveryRejectedIcon from "assets/icons/erx-delivery-rejected-icon.svg";
import DeliveryCancelledIcon from "assets/icons/erx-delivery-cancelled-icon.svg";
import PoslajuIcon from "assets/icons/erx-poslaju-icon.svg";
import LalamoveIcon from "assets/icons/erx-lalamove-icon.svg";
import UserIcon from "assets/icons/UserIcon.svg";
import PhoneIcon from "assets/icons/PhoneIcon.svg";

import PickupLocationModal from "./PickupLocationModal";

function PrescriptionDetails({ id, switchToTab }) {
  const [detailLoading, setDetailLoading] = useState(false);
  const [modalLoading, setModalLoading] = useState(false);
  const [prescription, setPrescription] = useState(null);
  const [practiceLocation, setPracticeLocation] = useState(
    JSON.parse(localStorage.getItem("practice_location"))
  );
  const [showPickupLocationModal, setShowPickupLocationModal] = useState(false);
  const [pickupLocations, setPickupLocations] = useState(null);

  useEffect(() => {
    if (id) {
      setDetailLoading(true);
      getPrescription();
    } else {
      setPrescription(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const getPrescription = () => {
    PrescriptionService.getPrescription(id).then(
      (data) => {
        setPrescription(data.prescription);
        setDetailLoading(false);
        if (data?.prescription.status === "pending_pickup_location") {
          getPickupLocations();
        } else if (data?.prescription.status === "pending_confirmation") {
          if (data?.prescription?.pickup_location) {
            setPickupLocations([
              {
                id: null,
                value: data?.prescription.pickup_location.practice_location_id,
                label: `${data?.prescription.pickup_location.name} (Default)`,
                description: data?.prescription.pickup_location.address,
              },
            ]);
          }
        }
      },
      (error) => {
        if (error.response.status === 401) {
          AuthService.logout();
          window.location.replace("/eb/login");
        }
      }
    );
  };

  const getPickupLocations = () => {
    var params = {
      practice_location_id: practiceLocation?.id,
    };

    PrescriptionService.getPickupLocations(params).then(
      (data) => {
        setPickupLocations(data);
      },
      (error) => {
        if (error.response.status === 401) {
          AuthService.logout();
          window.location.replace("/eb/login");
        }
      }
    );
  };

  const ActionButton = () => {
    switch (prescription.status) {
      case "pending_pickup_location":
      case "pending_confirmation":
        return (
          <div className="container">
            <button
              className="btn action-btn accept-btn"
              onClick={() => setShowPickupLocationModal(true)}
            >
              Review Pickup Location
            </button>
            <button
              className="btn action-btn reject-btn"
              onClick={() => rejectForDelivery()}
            >
              Reject
            </button>
          </div>
        );
      case "shipping_request_pending":
      case "paid":
        return (
          <div className="container">
            <button
              className="btn action-btn share-quotation-btn"
              onClick={() => setReadyForPickup()}
            >
              Ready For Pickup
            </button>
          </div>
        );
      default:
        return <div></div>;
    }
  };

  const DeliveryBadge = ({ courier }) => {
    if (courier !== "Lalamove") {
      return (
        <Badge className="badge">
          <div className="next-day rounded-pill">NEXT DAY</div>
        </Badge>
      );
    } else {
      return (
        <Badge className="badge">
          <div className="express rounded-pill">EXPRESS</div>
        </Badge>
      );
    }
  };

  const DeliveryStatus = () => {
    const {
      status,
      connote_url,
      driver_details,
      delivery_tracking_url,
      courier,
    } = prescription;

    const renderContainer = (content) => (
      <div>
        <div className="label">Medicine Delivery Status</div>
        <div className="status">
          <div className="delivery-status">
            <div className="container">{content}</div>
          </div>
        </div>
      </div>
    );

    const renderTrackButton = () => (
      <a
        className="btn track-btn"
        href={delivery_tracking_url}
        target="_blank"
        rel="noreferrer noopener"
      >
        Track
      </a>
    );

    const renderDriverDetails = () => (
      <div className="driver-details">
        <div className="d-flex justify-content-between">
          <div className="title">Driver is on the way</div>
          {/* <div className="time-container"> */}
          {/* <div className="time">30 mins</div> */}
          {/* </div> */}
        </div>
        <hr />
        <div className="d-flex justify-content-between">
          <div className="info">
            <div className="name">
              <img src={UserIcon} className="icon" alt="user-icon" />
              {driver_details?.driver_name}
            </div>
            <div className="phone">
              <img src={PhoneIcon} className="icon" alt="phone-icon" />
              {driver_details?.driver_phone}
            </div>
          </div>
          <div className="vehicle">{driver_details?.driver_plate_no}</div>
        </div>
      </div>
    );

    switch (status) {
      case "pending_shipping_fee":
      case "quote":
        return renderContainer(
          <span className="yellow">
            Pending Payment{" "}
            <img src={PaymentIcon} className="icon" alt="payment-icon" />
          </span>
        );
      case "processing":
        return renderContainer(
          <span className="yellow">
            Processing Order{" "}
            <img src={ProcessingIcon} className="icon" alt="processing-icon" />
          </span>
        );
      case "paid":
        return renderContainer(
          <span className="yellow">
            Prepare Your Package{" "}
            <img src={PrepareIcon} className="icon" alt="prepare-icon" />
          </span>
        );
      case "ready_for_pickup":
      case "shipping_request_pending":
        if (connote_url) {
          return (
            <>
              {renderContainer(
                <span className="yellow">
                  Ready For Pickup{" "}
                  <img src={ReadyIcon} className="icon" alt="ready-icon" />
                </span>
              )}
              <div className="print-consignment mt-6">
                <div className="container">
                  <div className="action-info">
                    Make sure to print the provided consignment note and attach
                    it to your parcel for delivery.
                  </div>
                  <button
                    className="pending-shipping-request-btn"
                    onClick={() => openConsignmentNotePage()}
                  >
                    Print Consignment Note →
                  </button>
                </div>
              </div>
            </>
          );
        } else if (driver_details) {
          return (
            <>
              <div className="d-flex pb-6">
                {renderContainer(
                  <span className="yellow">
                    Ready For Pickup{" "}
                    <img src={ReadyIcon} className="icon" alt="ready-icon" />
                  </span>
                )}
                {delivery_tracking_url && renderTrackButton()}
              </div>
              {renderDriverDetails()}
            </>
          );
        } else {
          return renderContainer(
            <span className="yellow">
              Ready For Pickup{" "}
              <img src={ReadyIcon} className="icon" alt="ready-icon" />
            </span>
          );
        }

      case "delivery_in_progress":
        return (
          <>
            <div className="d-flex pb-6">
              {renderContainer(
                <span className="yellow">
                  Delivering{" "}
                  <img
                    src={DeliveringIcon}
                    className="icon"
                    alt="deliver-icon"
                  />
                </span>
              )}
              {delivery_tracking_url && renderTrackButton()}
            </div>
            {driver_details && renderDriverDetails()}
          </>
        );

      case "delivery_done":
        return (
          <div className="d-flex">
            {renderContainer(
              <span className="green">
                Completed!{" "}
                <img src={DeliveredIcon} className="icon" alt="deliver-icon" />
              </span>
            )}
            {courier === "Pos Laju" &&
              delivery_tracking_url &&
              renderTrackButton()}
          </div>
        );

      case "shipping_failed":
        return (
          <>
            {renderContainer(
              <span className="red">
                Failed!{" "}
                <img
                  src={DeliveryFailedIcon}
                  className="icon"
                  alt="delivery-failed-icon"
                />
              </span>
            )}
            <div className="note">
              <span className="red">Delivery attempt unsuccessful.</span>
            </div>
          </>
        );

      case "shipping_request_failed":
        return (
          <>
            {renderContainer(
              <span className="red">
                Failed!{" "}
                <img
                  src={DeliveryFailedIcon}
                  className="icon"
                  alt="delivery-failed-icon"
                />
              </span>
            )}
            <div className="note">
              <span className="red">Delivery request failed.</span>
            </div>
          </>
        );
      case "reject_clinic":
        return (
          <>
            {renderContainer(
              <span className="red">
                Rejected!{" "}
                <img
                  src={DeliveryRejectedIcon}
                  className="icon"
                  alt="delivery-rejected-icon"
                />
              </span>
            )}
            <div className="note">
              <span className="red">Order was declined by administration.</span>
            </div>
          </>
        );
      case "reject_delivery":
        return (
          <>
            {renderContainer(
              <span className="red">
                Rejected!{" "}
                <img
                  src={DeliveryRejectedIcon}
                  className="icon"
                  alt="delivery-rejected-icon"
                />
              </span>
            )}
            <div className="note">
              <span className="red">
                Order was declined by delivery partner.
              </span>
            </div>
          </>
        );

      case "expired":
        return (
          <>
            {renderContainer(
              <span className="red">
                Expired!{" "}
                <img
                  src={DeliveryExpiredIcon}
                  className="icon"
                  alt="delivery-expired-icon"
                />
              </span>
            )}
            <div className="note">
              <span className="red">
                No response from the user within allocated time
              </span>
            </div>
          </>
        );

      case "cancelled":
        return (
          <>
            {renderContainer(
              <span className="red">
                Cancelled!{" "}
                <img
                  src={DeliveryCancelledIcon}
                  className="icon"
                  alt="delivery-cancelled-icon"
                />
              </span>
            )}
            <div className="note">
              <span className="red">
                Cancelled automatically by BookDoc’s system
              </span>
            </div>
          </>
        );

      default:
        return <span>-</span>;
    }
  };

  const shareQuotation = () => {
    setModalLoading(true);
    var params = {
      pickup_location_type: practiceLocation?.type || "PracticeLocation",
      pickup_location_id: practiceLocation?.id,
    };

    if (
      params.pickup_location_type === "DoctorChatInfoClinic" &&
      params.pickup_location_id === null
    ) {
      params = { ...params, name: practiceLocation?.name };
    }

    PrescriptionService.confirmPickupLocation(prescription.id, params).then(
      (data) => {
        if (data?.prescription) {
          setPrescription(data.prescription);
        }
        setModalLoading(false);
        setShowPickupLocationModal(false);
        switchToTab("quote");
      },
      (error) => {
        if (error.response.status === 401) {
          AuthService.logout();
          window.location.replace("/eb/login");
        }
      }
    );
  };

  const rejectForDelivery = () => {
    setModalLoading(true);
    PrescriptionService.rejectForDelivery(prescription.id).then(
      (data) => {
        if (data?.prescription) {
          setPrescription(data.prescription);
          setModalLoading(false);
          switchToTab("request");
        }
      },
      (error) => {
        if (error.response.status === 401) {
          AuthService.logout();
          window.location.replace("/eb/login");
        }
      }
    );
  };

  const setReadyForPickup = () => {
    readyForPickup();
    switchToTab("ready");
  };

  const readyForPickup = () => {
    setModalLoading(true);
    PrescriptionService.readyForPickup(prescription.id).then(
      (data) => {
        if (data?.prescription) {
          setPrescription(data.prescription);
          setModalLoading(false);
        }
      },
      (error) => {
        if (error.response.status === 401) {
          AuthService.logout();
          window.location.replace("/eb/login");
        }
      }
    );
  };

  const openConsignmentNotePage = () => {
    window.open(prescription.connote_url, "_blank").focus();
  };

  const DeliverBy = ({ courier }) => {
    switch (courier) {
      case "Pos Laju":
        return (
          <div className="d-flex justify-content-end">
            <img src={PoslajuIcon} className="px-2" alt="poslaju-icon"></img>
            <div className="bold-600">POSLAJU</div>
          </div>
        );
      case "Lalamove":
        return (
          <div className="d-flex justify-content-end">
            <img src={LalamoveIcon} className="px-2" alt="lalamove-icon"></img>
            <div className="bold-600">LALAMOVE</div>
          </div>
        );
      default:
        return (
          <div className="d-flex justify-content-end">
            <div className="bold-600">{courier.toUpperCase()}</div>
          </div>
        );
    }
  };

  return (
    <Col md={9} className="prescription-details-container scrollbar-grey">
      {(() => {
        if (detailLoading) {
          return (
            <div className="loader">
              <Spinner animation="border" className="spinner" />
            </div>
          );
        } else if (prescription === null) {
          return (
            <div className="empty-prescription-details">
              No prescription selected
            </div>
          );
        } else {
          return (
            <Row className="wrapper h-100">
              <Col md={4} className="prescription-details">
                <div className="prescription-container">
                  <section>
                    <div className="container">
                      <div className="ref-label">Reference No:</div>
                      {prescription?.courier &&
                        prescription?.status !== "quote" && (
                          <DeliveryBadge
                            courier={prescription.courier}
                          ></DeliveryBadge>
                        )}
                      <p className="ref-value">{prescription?.reference_no}</p>
                    </div>

                    {[
                      "quote",
                      "paid",
                      "pending_shipping_fee",
                      "ready_for_pickup",
                      "processing",
                      "shipping_request_pending",
                      "delivery_in_progress",
                      "delivery_done",
                      "shipping_failed",
                      "reject_delivery",
                      "reject_clinic",
                      "shipping_request_failed",
                      "expired",
                      "cancelled",
                    ].includes(prescription.status) && (
                      <React.Fragment>
                        <hr />
                        <div className="delivery-status-container justify-content-between align-items-center mb-5">
                          <div>
                            <DeliveryStatus
                              prescription={prescription}
                            ></DeliveryStatus>
                          </div>
                        </div>{" "}
                      </React.Fragment>
                    )}
                  </section>

                  <div className="delivery-container">
                    <section>
                      <div className="d-flex justify-content-between">
                        <div className="label">FROM</div>
                        <div className="value address-container">
                          {prescription?.pickup_location ? (
                            <>
                              <div className="sender">
                                {prescription?.pickup_location?.name}
                              </div>
                              <div className="address from">
                                {prescription?.pickup_location?.address}
                              </div>
                            </>
                          ) : (
                            <div className="address none">
                              No pickup location chosen
                            </div>
                          )}
                        </div>
                      </div>
                      <hr />
                      <div className="d-flex justify-content-between">
                        <div className="label">TO</div>
                        <div className="value address-container">
                          <div className="recipient">
                            {prescription?.recipient.name}
                          </div>
                          <div className="address to">
                            {prescription?.dropoff_location?.full_address}
                          </div>
                          <div className="phone">
                            +{prescription?.recipient.phone_number}
                          </div>
                        </div>
                      </div>
                      {prescription?.courier &&
                        prescription?.status !== "quote" && (
                          <React.Fragment>
                            <hr />
                            <div className="d-flex justify-content-between">
                              <div className="label">DELIVER TYPE</div>
                              <div className="value address-container">
                                <div className="address">
                                  {prescription.courier === "Lalamove"
                                    ? "EXPRESS DELIVERY"
                                    : "NEXT DAY DELIVERY"}
                                </div>
                              </div>
                            </div>
                            <hr />
                            <div className="d-flex justify-content-between">
                              <div className="label">DELIVER BY</div>
                              <div className="value address-container">
                                <div className="address">
                                  <DeliverBy
                                    courier={prescription?.courier}
                                  ></DeliverBy>
                                </div>
                              </div>
                            </div>
                          </React.Fragment>
                        )}
                    </section>
                  </div>
                  <section>
                    {modalLoading ? (
                      <div className="loader">
                        <Spinner animation="border" className="spinner" />
                      </div>
                    ) : (
                      <ActionButton />
                    )}
                  </section>
                </div>
              </Col>

              <Col md={8} className="medicine-details">
                <div className="details-container">
                  <Table className="medicines-list">
                    <thead>
                      <tr className="table-header px-4 py-3 my-6">
                        <th width="10%" className="text-center">
                          NO
                        </th>
                        <th>ITEMS</th>
                        <th width="15%" className="text-center">
                          QTY
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {prescription?.prescription_medicines.map(
                        (medicine, index) => (
                          <tr key={`med-${index}`}>
                            <td className="text-center font-weight-mid-bold">
                              {index + 1}
                            </td>
                            <td className="med-prescriptions">
                              <div className="med-name">
                                {medicine.medicine.name}
                              </div>
                              <div>
                                ({medicine.consumption_quantity}){" "}
                                {medicine.consumption_unit}
                              </div>
                              <div>
                                ({medicine.consumption_per_day}) Times Daily
                              </div>
                              <div>({medicine.consumption_days}) Days</div>
                              {medicine.consumption_to_complete && (
                                <div>To Complete</div>
                              )}
                              {medicine.consume_before_meal && (
                                <div>Before Meal</div>
                              )}
                              {medicine.consume_after_meal && (
                                <div>After Meal</div>
                              )}
                              {medicine.consume_when_necessary && (
                                <div>When Necessary</div>
                              )}
                              {medicine.consumption_cause_drowsiness && (
                                <div>Cause Drowsiness</div>
                              )}
                            </td>
                            <td className="text-center font-weight-mid-bold">
                              {medicine.quantity}
                            </td>
                          </tr>
                        )
                      )}
                    </tbody>
                  </Table>

                  <div className="prescription-details">
                    <div className="d-flex justify-content-between">
                      <div className="label">ERX ISSUED BY</div>
                      <div className="value content-container">
                        <div className="name">{prescription?.doctor_name}</div>
                        <div className="specialties">
                          {prescription?.doctor_specialties}
                        </div>
                        <div className="address">
                          {prescription?.doctor_practice_location_address}
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr />
                  <div className="prescription-details">
                    <div className="d-flex justify-content-between">
                      <div className="label">ERX ISSUED DATE</div>
                      <div className="value content-container">
                        <div className="content">
                          {moment(prescription?.created_at).format(
                            "DD MMM YYYY"
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr />
                  <div className="prescription-details">
                    <div className="d-flex justify-content-between">
                      <div className="label">TIME</div>
                      <div className="value content-container">
                        <div className="content">
                          {moment(prescription?.created_at).format("h:mm A")}{" "}
                          (GMT/UTC+08:00)
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr />
                  <div className="prescription-details">
                    <div className="d-flex justify-content-between">
                      <div className="label">PATIENT NAME</div>
                      <div className="value content-container">
                        <div className="content">
                          {prescription?.recipient.name}
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr />
                  <div className="prescription-details">
                    <div className="d-flex justify-content-between">
                      <div className="label">NRIC/PASSPORT NO.</div>
                      <div className="value content-container">
                        <div className="content">
                          {prescription?.recipient.nric}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
              <PickupLocationModal
                show={showPickupLocationModal}
                setShowPickupLocationModal={setShowPickupLocationModal}
                pickupLocations={pickupLocations}
                setPracticeLocation={setPracticeLocation}
                shareQuotation={shareQuotation}
                modalLoading={modalLoading}
              />
            </Row>
          );
        }
      })()}
    </Col>
  );
}

export default PrescriptionDetails;
